import { IReportState } from '../../types/redux/report';
import { TReduxActions } from '../../types/redux/actions';
import { EReportStatus } from '../../constants/report';
import { EReportActions } from '../../constants/actionTypes/report';

export const defaultState = {
  reportStatus: EReportStatus.Default,
};

export function reportReducer(state: IReportState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EReportActions.TOGGLE_REPORT_STATE:
      return {
        ...state,
        reportStatus: action.payload,
        errorText: '',
      };

    case EReportActions.TOGGLE_LOADING:
      return {
        ...state,
        isSaveLoading: action.payload,
      };

    case EReportActions.TOGGLE_ERROR:
      return {
        ...state,
        errorText: action.payload,
      };

    case EReportActions.SET_SHARE_REPORT_URL:
      return {
        ...state,
        shareReportUrl: action.payload,
      };

    default:
      return state;
  }
}
